/*
 * SMParts — Bike-Buehne
 *
 * Zwei Aufgaben:
 *
 *   Die Knoepfe oeffnen den Waehler, der schon in der Kopfzeile sitzt.
 *   Die Buehne baut bewusst keinen eigenen — zwei Waehler auf einer
 *   Seite hiessen zwei Zustaende, die auseinanderlaufen koennen.
 *
 *   Die Buehne zeigt, ob schon ein Bike gesetzt ist. Das steht nur im
 *   Browser und kann vom Server nicht bekannt sein, deshalb wird der
 *   Zustand erst hier gesetzt. Bis dahin steht die Frage da — der
 *   richtige Rueckfall, denn wer noch kein Bike hat, ist die Mehrheit.
 */
(function () {
  'use strict';

  var SPEICHER = 'smp:bike';
  var GEAENDERT = 'smp:bike-changed';

  function bike() {
    try {
      var roh = window.localStorage.getItem(SPEICHER);
      var b = roh ? JSON.parse(roh) : null;
      return b && b.marke ? b : null;
    } catch (e) {
      return null;
    }
  }

  function name(b) {
    return [b.marke, b.modell, b.baujahr].filter(Boolean).join(' · ');
  }

  /* Oeffnet die Lade in der Kopfzeile. */
  function ladeOeffnen() {
    var knopf = document.querySelector('[data-smp-bike-knopf]');
    var blatt = document.querySelector('[data-smp-bike-blatt]');
    if (!knopf) return null;
    if (blatt && blatt.hidden) knopf.click();
    return blatt;
  }

  /*
   * Marke vorwaehlen: nach dem Oeffnen steht die Markenliste im Blatt.
   * Der Waehler bietet dafuer keine Schnittstelle an, also wird der
   * Knopf mit dem passenden Namen angeklickt — derselbe Weg, den ein
   * Finger nimmt.
   *
   * Die Liste wird erst beim Oeffnen gefuellt, deshalb ein paar
   * Versuche statt eines einzigen Zugriffs.
   */
  function markeWaehlen(marke, versuche) {
    versuche = versuche === undefined ? 12 : versuche;
    var blatt = document.querySelector('[data-smp-bike-blatt]');
    if (!blatt) return;

    var treffer = Array.prototype.find.call(
      blatt.querySelectorAll('[data-smp-bike-options] button'),
      function (b) {
        return b.textContent.trim().toLowerCase() === marke.trim().toLowerCase();
      }
    );

    if (treffer) {
      treffer.click();
      return;
    }

    if (versuche > 0) {
      window.setTimeout(function () { markeWaehlen(marke, versuche - 1); }, 80);
    }
    /* Nicht gefunden: die Lade bleibt offen, der Besucher waehlt
       selbst. Besser als ein Fehler, der nichts tut. */
  }

  function zeichnen(buehne) {
    var b = bike();
    var frage = buehne.querySelector('[data-smp-bb-frage]');
    var gesetzt = buehne.querySelector('[data-smp-bb-gesetzt]');
    var feld = buehne.querySelector('[data-smp-bb-name]');
    var zweit = buehne.querySelector('[data-smp-bb-zweit]');
    var knopftext = buehne.querySelector('[data-smp-bb-knopftext]');

    if (b) {
      if (frage) frage.hidden = true;
      if (gesetzt) gesetzt.hidden = false;
      if (feld) feld.textContent = name(b);
      if (zweit) zweit.hidden = false;
      if (knopftext && buehne.dataset.gesetztText) knopftext.textContent = buehne.dataset.gesetztText;
    } else {
      if (frage) frage.hidden = false;
      if (gesetzt) gesetzt.hidden = true;
      if (zweit) zweit.hidden = true;
      if (knopftext && buehne.dataset.frageText) knopftext.textContent = buehne.dataset.frageText;
    }
  }

  function aufbauen(buehne) {
    if (buehne.smpBereit) return;
    buehne.smpBereit = true;

    var knopftext = buehne.querySelector('[data-smp-bb-knopftext]');
    if (knopftext) buehne.dataset.frageText = knopftext.textContent.trim();

    zeichnen(buehne);

    var haupt = buehne.querySelector('[data-smp-bb-oeffnen]');
    if (haupt) haupt.addEventListener('click', function () { ladeOeffnen(); });

    buehne.querySelectorAll('[data-smp-bb-marke]').forEach(function (kachel) {
      kachel.addEventListener('click', function () {
        ladeOeffnen();
        markeWaehlen(kachel.dataset.smpBbMarke);
      });
    });

    document.addEventListener(GEAENDERT, function () { zeichnen(buehne); });
  }

  function start() {
    document.querySelectorAll('[data-smp-bikebuehne]').forEach(aufbauen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
